import * as React from 'react'
import { Button } from 'DVWebNodeUI'
import * as st from './bottomBar.module.scss'
import { ModalTrigger } from '../../utils/ModalTrigger'
import { ShareIcons } from '../shareIcons/shareIcons'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import { RecordRefTag } from '../recordReftag/recordReftag'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export interface IShareModalProps {
  isMobile: boolean
  shareIcons?: WpsRuntime.atv.wps.ShareIconsModel
  fullDetailUrl: WpsRuntime.atv.wps.SiteURL
  copyUrlReftag: string;
}

const shareContent = (props: IShareModalProps) =>
  <div>
    {props.shareIcons && <ShareIcons shareIcons={props.shareIcons}/>}
    <CopyLinkButton url={props.fullDetailUrl} reftag={props.copyUrlReftag}/>
  </div>


const shareHeader = () =>
  <strong className={st.shareHeader}>
    <TextLocalizer stringID={StringId.DV_DP_SHARE}/>
  </strong>

interface LinkWithCopyProps {
  url: string
  reftag?: string
}

interface LinkWithCopyState {
  buttonStringId: StringId
}

class CopyLinkButton extends React.Component<LinkWithCopyProps, LinkWithCopyState>{
  constructor(props: LinkWithCopyProps) {
    super(props)
    this.state = {
      buttonStringId: StringId.DV_DP_SHARE_COPY_LINK
    }
  }

  onClickHandler = (e: MouseEvent) => {
    this.setState({ buttonStringId: StringId.DV_DP_SHARE_COPIED })
    copyLink(this.props.url)
    e.stopPropagation()
  }

  render() {
    const { buttonStringId } = this.state
    return(
      <RecordRefTag refTag={this.props.reftag}>
        <Button className={st.linkButton} onClick={this.onClickHandler} data-automation-id="copy-url-button"
                data-testid="copy-url-button">
          <TextLocalizer stringID={buttonStringId}/>
        </Button>
      </RecordRefTag>
    )
  }
}

// Copies the current page url into the clipboard
const copyLink = (url: string) => {
  const textarea = document.createElement('textarea')
  textarea.value = url
  textarea.readOnly = true
  textarea.setAttribute('display', 'none')
  document.body.appendChild(textarea)
  textarea.select()
  textarea.setSelectionRange(0, url.length)
  document.execCommand('copy')
  textarea.remove()
}

export const ShareModalComp = (props: IShareModalProps) =>
  <ModalTrigger
    modalHeader={shareHeader}
    modalContent={shareContent(props)}
    toggle={({ openModalClickHandler }) => (
      <button id="shareTrigger" className={st.shareButton} onClick={openModalClickHandler}
              data-automation-id="share-button" data-testid="share-button">
        <TextLocalizer stringID={StringId.DV_DP_SHARE}/>
      </button>
    )}
    className={`${st.shareModal}`}
  />

export const ShareModal = ShareModalComp
